import { isModelWithError, ModelWithError } from './apiTypes';

const getErrorResponse = (responseContent, defaultMessage: string): Promise<any> => {
    return Promise.reject((responseContent as ModelWithError).Errors[0] || getErrorObject(defaultMessage));
}

const getErrorObject = (message: string) => { Message: message };

//Useful function to consolidate the handling of the the response functions coming back from the APIs.
//Ensures that the responses are converted into promise format to be used in other functions.
export async function ProcessFetchResponse(response: Response): Promise<any> {

    //Don't call json on an empty response.
    if (response.status === 204) {
        return Promise.resolve();
    }
    
    const responseContent = await response.json();
    const isError = isModelWithError(responseContent);

    switch (response.status) {
        case 200:
            if (isError) {
                return Promise.reject((responseContent as ModelWithError).Errors[0]);
            } else {
                return responseContent;
            }
        case 400:
            return getErrorResponse(responseContent, "Error Occurred: Bad Request.");
        case 401:
            return getErrorResponse(responseContent, "Error Occurred: Unauthorised");
        case 404:
            return getErrorResponse(responseContent, "Error Occurred: Not Found");
        case 409:
            return getErrorResponse(responseContent, "Error Occurred: Conflict");
        case 500:
            return getErrorResponse(responseContent, "Unexpected Error Occurred");
        default:
            return Promise.reject("Unexpected Error Occurred");
    }
}

const getCodedExceptionResponse = (responseContent, defaultMessage: string): Promise<any> => {
    return Promise.reject((responseContent) || getErrorObject(defaultMessage));
}

export async function ProcessCodedExceptionResponse(response: Response): Promise<any> {
    //Don't call json on an empty response.
    if (response.status === 204) {
        return Promise.resolve();
    }

    const responseContent = await response.json();

    switch (response.status) {
        case 200:
            return responseContent;
        case 400:
            return getCodedExceptionResponse(responseContent, "Error Occurred: Bad Request.");
        case 401:
            return getCodedExceptionResponse(responseContent, "Error Occurred: Unauthorised");
        case 404:
            return getCodedExceptionResponse(responseContent, "Error Occurred: Not Found");
        case 409:
            return getCodedExceptionResponse(responseContent, "Error Occurred: Conflict");
        case 500:
            return getCodedExceptionResponse(responseContent, "Unexpected Error Occurred");
        default:
            return Promise.reject("Unexpected Error Occurred");
    }
}
